module.exports = __webpack_public_path__ + "img/closeIconDark.4a096692.svg";